import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapState([ 
            'user',
            'appName',
            'baseURL',
            'loading',
            'selected_user',
            'storageDir',
        ]),
    },

    methods: {
        ...mapMutations([ 
            'updateAppName',
            'updateUser',
            'updateSelectedUser',
        ]),
        ...mapActions([
            'changeLoading',
            'changeSelectedUser'
        ]),
    }
    
    
}